// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, portfoliosSelectors, uiActions} from '@/store'

type Props = {
  name: string,
  deleteCompanies: () => void,
  showConfirmModal: (props: ModalProps) => void,
  l: Language,
  disabled: boolean,
}

const RawDeleteButton = (props: Props) =>
  <button id='delete_button'
    className="btn btn-danger"
    type="button"
    disabled={props.disabled}
    onClick={() => props.showConfirmModal({
      onConfirm: props.deleteCompanies,
      message: '',
    })}
  >
    {props.l('Delete')}
  </button>

const mapStateToProps = (state) => ({
  name: portfoliosSelectors.getActivePortfolioName(state),
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawDeleteButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/delete-button.js